export default __webpack_public_path__ + "static/media/3h.204035c2.png";